import React from "react";

import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { SelectField } from "../FieldService";
import {
	InformationRight,
	ReportFieldRights
} from "core/blueprint/trajectory/TrajectoryBlueprintService";

export type SelectInputProps = {
	field: SelectField;
	rights: ReportFieldRights;
	editable: boolean;
	onChange: (uuid: string, value: string) => void;
};

const SelectInput: React.FC<SelectInputProps> = (props: SelectInputProps) => {
	function isValid(value: string): boolean {
		return props.field.required
			? props.field.options.some(option => option.value === value)
			: true;
	}

	function onChange(newValue: string): void {
		props.onChange(props.field.uuid, newValue);
	}

	function toId(uuid: string): string {
		const separatorIndex = uuid.indexOf("#");
		return separatorIndex === -1 ? uuid : uuid.substring(0, separatorIndex);
	}

	return (
		<Grid item>
			<Typography>{props.field.name}</Typography>
			<TextField
				id={props.field.name}
				select
				fullWidth
				disabled={
					!props.editable ||
					props.rights[toId(props.field.uuid)][
						InformationRight.WRITE
					] === false
				}
				required={props.field.required}
				error={!isValid(props.field.value)}
				value={props.field.value ?? ""}
				onChange={event => onChange(event.target.value)}>
				<MenuItem value="">
					<p style={{ margin: 12 }} />
				</MenuItem>
				{props.field.options?.map((option, index) => (
					<MenuItem key={index} value={option.value}>
						{option.value}
					</MenuItem>
				))}
			</TextField>
		</Grid>
	);
};

export default SelectInput;
